/** Situações da entidade LocalFaturamento */
export interface LocalFaturamentoSituacao {
    id: number,
    nome: string;
}

export const localFaturamentoAtivo: LocalFaturamentoSituacao = {id: 1, nome: 'Ativo'};
export const localFaturamentoInativo: LocalFaturamentoSituacao = {id: 2, nome: 'Inativo'};

export const LocalFaturamentoSituacoes: LocalFaturamentoSituacao[] = [
    localFaturamentoAtivo,
    localFaturamentoInativo
];


/** Verifica se a situação informada é igual a Ativo */
export function isLocalFaturamentoSituacaoAtivo(situacao: number): boolean {
    if (!situacao) {
        return false;
    }
    return situacao === localFaturamentoAtivo.id;
}

/** Verifica se a situação informada é igual a Inativo */
export function isLocalFaturamentoSituacaoInativo(situacao: number): boolean {
    if (!situacao) {
        return false;
    }
    return situacao === localFaturamentoInativo.id;
}
